import React from "react"
import Sponsor from '../components/Sponsor/Sponsor'
import Layout from '../components/layout';
import CoverImage from '../components/CoverImage/CoverImage'


const Lag = () => (
  <Layout>
    <CoverImage text="Sponsorer" image="https://smorasstats.com/v4/wp-content/uploads/2020/04/meadow-grass-sunshine-wide-scaled.jpg" />
    <div className="col-12">
      <Sponsor/>
    </div>
  </Layout>
)

export default Lag